import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { ThemeProvider, ModalProvider } from '@xfers/design-system'
import { ConfigManager } from '~/managers/ConfigManager'
import PageLoader from '~/components/PageLoader'
import appStore from '~/app/store/store'
import AppRoot from '~/app/Root'
import bizStore from '~/biz/store/store'
import BizRoot from '~/biz/Root'
import SSOManager from '~/managers/SSOManager'

Sentry.init({
  dsn: 'https://0a970dc114f1455ba1541d1afdfb6a76@o441558.ingest.sentry.io/5417243',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: ConfigManager.getReactEnv(),
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
  ],
  // eslint-disable-next-line @typescript-eslint/typedef
  beforeSend(event, hint) {
    const exception = hint && hint.originalException
    let message = ''
    if (typeof exception === 'string') {
      message = exception
    }
    if (exception instanceof Error) {
      message = exception.message
    }
    if (message.match(/ResizeObserver loop/g)) {
      return null
    }
    return event
  },
})
Sentry.setTag('locale', ConfigManager.getCountry())
Sentry.setTag('site_type', ConfigManager.getSiteType())
ConfigManager.setupGA()

const App = () => {
  useEffect(() => {
    if (!SSOManager.isLogined()) {
      SSOManager.ssoLogin()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!SSOManager.isLogined()) {
    return <PageLoader />
  }

  if (ConfigManager.isAppSite()) {
    return (
      <Sentry.ErrorBoundary fallback={'An error has occured'}>
        <Provider store={appStore}>
          <BrowserRouter>
            <ThemeProvider>
              <ModalProvider>
                <AppRoot />
              </ModalProvider>
            </ThemeProvider>
          </BrowserRouter>
        </Provider>
      </Sentry.ErrorBoundary>
    )
  } else if (ConfigManager.isBizSite() || ConfigManager.isRegionalSite()) {
    return (
      <Sentry.ErrorBoundary fallback={'An error has occured'}>
        <Provider store={bizStore}>
          <BrowserRouter>
            <ThemeProvider>
              <ModalProvider>
                <BizRoot />
              </ModalProvider>
            </ThemeProvider>
          </BrowserRouter>
        </Provider>
      </Sentry.ErrorBoundary>
    )
  }
  return <PageLoader />
}

export default App
